import Vue from 'vue'
import Vuex from 'vuex'

// eslint-disable-next-line
export const fb = firebase
fb.initializeApp({
  apiKey: 'AIzaSyCEJ8W9gkQZ2zTFpF-rL9spRVToEUTGF1c',
  authDomain: 'cachalog.jp',
  databaseURL: 'https://cachalog-prod.firebaseio.com',
  projectId: 'cachalog-prod',
  storageBucket: 'cachalog-prod.appspot.com',
  messagingSenderId: '481160226756',
  appId: '1:481160226756:web:6c701835c430d141252691',
  measurementId: 'G-S5WC8G4ER3'
})
fb.analytics()
export const db = fb.firestore()

export function datestr (date, format) {
  format = format.replace(/Y/, date.getFullYear())
  format = format.replace(/m/, ('00' + (date.getMonth() + 1)).slice(-2))
  format = format.replace(/d/, ('00' + date.getDate()).slice(-2))
  format = format.replace(/H/, ('00' + date.getHours()).slice(-2))
  format = format.replace(/i/, ('00' + date.getMinutes()).slice(-2))
  format = format.replace(/s/, ('00' + date.getSeconds()).slice(-2))
  return format
}
datestr.date = 'Y/m/d'
datestr.dateTime = 'Y/m/d H:i:s'
datestr.time = 'H:i:s'
/*
function stripTags () {
  const raw = String.raw.apply(null, arguments)
  return raw.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}
*/
export function isJSON (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export function indexOf (array, key, value) {
  if (!Array.isArray(array)) {
    return false
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i][key] === value) {
      return i
    }
  }
  return false
}

export function arrayUnion (array, key, value) {
  const index = typeof value === 'object' ? indexOf(array, key, value[key]) : array.indexOf(value)
  if (index === false) {
    array.push(value)
    return null
  } else {
    return array.splice(index, 1, value)
  }
}

export function objectSort (obj) {
  const keys = Object.keys(obj).sort()
  const map = {}
  keys.forEach(key => {
    map[key] = (obj[key] && typeof obj[key] === 'object') ? objectSort(obj[key]) : obj[key]
  })
  return map
}

export function compareObject (a, b) {
  if (a === b) {
    return true
  }
  if (JSON.stringify(objectSort(a)) === JSON.stringify(objectSort(b))) {
    return true
  }
  return false
}

export function sortByTimestamp (array, fieldName, order) {
  if (array && array.length) {
    const left = order === 'asc' ? -1 : 1
    const right = order === 'asc' ? 1 : -1
    return array.sort((a, b) => {
      const aSeconds = a[fieldName].seconds || (a[fieldName].getTime() / 1000)
      const bSeconds = b[fieldName].seconds || (b[fieldName].getTime() / 1000)
      return (aSeconds || 0) < (bSeconds || 0) ? left : right
    })
  } else {
    return []
  }
}

export function sortItems (items) {
  return items.sort((a, b) => {
    if (a.sold_out === b.sold_out) {
      return 1
    } else {
      return b.sold_out ? -1 : 1
    }
  })
}

export function removeObjectFromArray (array, key, value) {
  const index = indexOf(array, key, value)
  if (index === false) {
    return []
  } else {
    return array.splice(index, 1)
  }
}
/*
function arrayRemove (array, value) {
  return array.splice(array.indexOf(value), 1)
}

function num2Comma (num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
}

function num2en (n) {
  const ns = [
    'zero','one','two','three','four','five','six','seven','eight','nine',
    'ten','eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen',
    'twenty','twenty one','twenty two','twenty three','twenty four','twenty five','twenty six','twenty seven','twenty eight','twenty nine',
    'thirty','thirty one','thirty two','thirty three','thirty four','thirty five','thirty six','thirty seven','thirty eight','thirty nine',
    'forty','forty one','forty two','forty three','forty four','forty five','forty six','forty seven','forty eight','forty nine',
    'fifty','fifty one','fifty two','fifty three','fifty four','fifty five','fifty six','fifty seven','fifty eight','fifty nine',
    'sixty','sixty one','sixty two','sixty three','sixty four','sixty five','sixty six','sixty seven','sixty eight','sixty nine',
    'seventy','seventy one','seventy two','seventy three','seventy four','seventy five','seventy six','seventy seven','seventy eight','seventy nine',
    'eighty','eighty one','eighty two','eighty three','eighty four','eighty five','eighty six','eighty seven','eighty eight','eighty nine',
    'ninety','ninety one','ninety two','ninety three','ninety four','ninety five','ninety six','ninety seven','ninety eight','ninety nine',
    'one hundred'
  ]
  return ns[n]
}
*/

export function xhr (url, callback) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.onreadystatechange = () => {
    switch (xhr.readyState) {
      case 4:
        const response = xhr.status < 300 ? xhr.responseText : '["no-response"]'
        callback(
          isJSON(response) ? JSON.parse(response) : response
        )
        break
    }
  }
  xhr.send()
  return false
}

/**
 * storeのactionに移動したい
 */
export function uploadStorage (data, metadata) {
  const storageRef = fb.storage().ref()
  const fileRef = storageRef.child(data.full_path)
  metadata.cacheControl = 'public,max-age=600'
  const uploadTask = fileRef.putString(
    data.source,
    'data_url',
    metadata
  )
  uploadTask.on('state_changed', snapshot => {
    // state.imageUploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
    switch (snapshot.state) {
      case fb.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused')
        break
      case fb.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running')
        break
    }
  },
  error => console.error(error),
  () => {
    console.log('complete')
    /* fileRef.updateMetadata({cacheControl: 'public,max-age=300'})
    .then(metadata => console.log(metadata))
    .catch(error => console.log(error)) */
  })
}

export function incrementCounter (ref, fieldName) {
  return db.runTransaction(t => {
    return t.get(ref).then(doc => {
      const count = (doc.data()[fieldName] || 0) - 0 + 1
      t.update(ref, { [fieldName]: count })
      return count.toString()
    })
  })
}

Vue.component('cachalog-img', {
  props: ['fullPath', 'caption', 'source', 'type', 'edit'],
  data: () => ({
    url: '/assets/img/noimage.svg',
    dataUri: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII='
  }),
  watch: {
    fullPath (value) {
      if (value) {
        this.setUrl()
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      cache: function (state) {
        return state.cache.images[this.fullPath]
      }
    }),
    alt () {
      return this.caption || 'Caption'
    },
    src () {
      return this.source || (this.cache ? this.cache.source : null) || this.url
    },
    noImage () {
      return this.src === this.url
    },
    backgroundUrl () {
      return this.edit && this.noImage ? 'none' : 'url(' + this.src + ')'
    }
  },
  created () {
    this.setUrl()
  },
  methods: {
    setUrl () {
      if (this.fullPath && !this.cache) {
        fb.storage().ref(this.fullPath).getDownloadURL()
          .then(url => {
            this.$store.commit('storeCacheImage', {
              fullPath: this.fullPath,
              source: url
            })
          })
          .catch(error => console.error(error))
      }
    }
  },
  template: `
<img class="background-image" v-if="type == 'background'" :src="dataUri"
  :class="{'no-image': noImage}"
  :style="{
    backgroundImage: backgroundUrl,
  }">
<img v-else :src="src" :alt="alt">
`
})

const cachalogPageNavTemplate = `
<nav id="page-nav" class="has-text-centered">
  <div class="tabs is-centered is-cs-4">
    <ul>
      <li :class="{'is-active': pageMainComponent == 'page'}">
        <router-link :to="{name: 'page'}">ショップ</router-link>
      </li>
      <!--<li :class="{'is-active': pageMainComponent == 'page-members'}">
        <router-link :to="{name: 'page-members'}">メンバー</router-link>
      </li>-->
      <li :class="{'is-active': pageMainComponent == 'page-sales'}">
        <router-link :to="{name: 'page-sales-index'}">販売履歴</router-link>
      </li>
    </ul>
  </div>
</nav>
`
Vue.component('cachalog-page-nav', {
  data: () => ({
  }),
  computed: {
    ...Vuex.mapState({
      pageMainComponent: 'pageMainComponent'
    })
  },
  methods: {
  },
  template: cachalogPageNavTemplate
})

Vue.component('cachalog-item-quantity', {
  props: ['index', 'wishlist', 'parent'],
  computed: {
    ...Vuex.mapState({
      page: 'page'
    }),
    item () {
      return this.wishlist.items[this.index]
    },
    wishlistType () {
      return this.parent === 'page' ? 'wishlist' : 'order'
    },
    quantity: {
      get () {
        return this.wishlist.items[this.index].quantity
      },
      set (value) {
        this.$store.commit('updateWishlistQuantity', {name: this.wishlistType, index: this.index, quantity: value})
      }
    }
  },
  methods: {
    increment () {
      if (!this.page.items[this.index].sold_out || this.parent === 'order') {
        this.$store.commit('updateWishlistQuantity', {name: this.wishlistType, index: this.index, method: 'increment'})
      }
    },
    decrement () {
      if (!this.page.items[this.index].sold_out || this.parent === 'order') {
        this.$store.commit('updateWishlistQuantity', {name: this.wishlistType, index: this.index, method: 'decrement'})
      }
    }
  },
  template: `
<div class="quantity">
  <span class="decrement" @click="decrement">
    <i class="c-icon cachalog-minus"></i>
  </span>
  <div class="select">
    <div class="quantity-value is-cs-0 has-text-align-center">
      <span>{{ quantity }}</span>
    </div>
    <select v-model="quantity">
      <option v-for="i in 100" :selected="quantity == i - 1" :value="i - 1">{{ i - 1 }}</option>
    </select>
  </div>
  <span class="increment" @click="increment">
    <i class="c-icon cachalog-plus"></i>
  </span>
</div>
  `
})

const cachalogItemListTemplate = `
<div class="item" :class="{r18: item.r18}">
  <router-link :to="{name: 'item', params: {pageId: page.id, itemId: item.id}}">
    <figure class="image">
      <cachalog-img :type="'background'" :caption="image.caption" :full-path="image.full_path"
        :source="image.source"></cachalog-img>
    </figure>
  </router-link>
  <div class="properties">
    <router-link :to="{name: 'item', params: {pageId: page.id, itemId: item.id}}">
      <p class="item-name is-cs-5 has-text-weight-bold">{{ item.name }}</p>
    </router-link>
    <p class="price is-cs-6">
    <template v-if="diff(item)">
      <div>
        <span>現在の価格</span>
        <span class="is-cs-4">{{ item.price.value.toLocaleString() }}</span> 円（{{ item.price.tax ? '税込' : '税抜' }}）
      </div>
      <div>
        <span>会計時の価格</span>
        <span class="is-cs-4">{{ item.orderPrice.value.toLocaleString() }}</span> 円（{{ item.price.tax ? '税込' : '税抜' }}）
      </div>
    </template>
    <template v-else>
      <span class="is-cs-4">{{ item.price.value.toLocaleString() }}</span> 円（{{ item.price.tax ? '税込' : '税抜' }}）
    </template>
    </p>
  </div>
  <cachalog-item-quantity
    v-if="active" :index="index" :wishlist="wishlist" :parent="parent">
  </cachalog-item-quantity>
  <div v-if="parent == 'sales'">{{ item.quantity || 0 }}</div>

  <div class="edit-icon" v-if="$store.getters.isMember && parent == 'page'">
    <router-link :to="{name: 'item-editor', params: {itemId: item.id}}">
      <i class="c-icon cachalog-edit">
        <span class="path1"></span><span class="path2"></span>
      </i>
    </router-link>
  </div>

</div>
`
Vue.component('cachalog-item-list', {
  props: ['item', 'index', 'parent', 'wishlist'],
  computed: {
    ...Vuex.mapState({
      page: 'page'
      // wishlist: 'wishlist',
    }),
    image () {
      return this.item.images && this.item.images[0] ? this.item.images[0] : {}
    },
    active () {
      /**
       * ウィッシュリストまたは注文画面で数量入力を表示する。
       */
      return (this.parent === 'page' && !this.$store.getters.isMember) || this.parent === 'order'
    }
  },
  methods: {
    diff (item) {
      return (item.orderPrice && (item.orderPrice.value !== item.price.value))
    }
  },
  template: cachalogItemListTemplate
})

const cachalogPageListTemplate = `
<li>
  <router-link :to="{name: 'page', params: {pageId: page.page_id || page.id}}">
    <figure class="image rectangle">
      <cachalog-img :type="'background'" :caption="bImage.caption"
        :full-path="bImage.full_path"
        :source="bImage.source"></cachalog-img>
    </figure>
    <figure class="image circle is-64x64">
      <cachalog-img class="is-rounded" :type="'background'" :caption="cImage.caption"
        :full-path="cImage.full_path"
        :source="cImage.source"></cachalog-img>
    </figure>
    <div>
      <p class="is-cs-5 is-c-normal-text has-text-weight-bold">{{ page.title }}</p>
    </div>
  </router-link>
</li>
`
Vue.component('cachalog-page-list', {
  props: ['page'],
  template: cachalogPageListTemplate,
  computed: {
    bImage () {
      return this.page.images && this.page.images[0] ? this.page.images[0] : {}
    },
    cImage () {
      return this.page.images && this.page.images[1] ? this.page.images[1] : {}
    }
  }
})

export const mixin = {
  props: ['routeTitle'],
  computed: {
    ogTitle () {
      if (!this.routeTitle) {
        return null
      }
      const replaces = this.routeTitle.match(/:([\w]+)/g) || []
      return replaces.reduce((title, replace) => {
        return title.replace(replace, this[replace.replace(':', '')])
      }, this.routeTitle)
    }
  },
  watch: {
    ogTitle: {
      immediate: true,
      handler (value) {
        if (!value) {
          return false
        }
        document.querySelector('title').textContent = value
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common.js